import React from 'react';
import LocationTemplate from './LocationTemplate';

const VaughanPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Vaughan"
      stateName="North Carolina"
      countyName="Warren"
      zipCodes={["27586"]}
      latitude={36.4335}
      longitude={-77.8845}
      population={269}
      historicalFact="Small town in Warren County named after the Vaughan family."
      nearbyTowns={[
        "Warrenton, NC",
        "Macon, NC",
        "Norlina, NC",
        "Henderson, NC",
        "Littleton, NC",
        "Hollister, NC",
        "Halifax, NC",
        "Weldon, NC"
      ]}
    />
  );
};

export default VaughanPage;